import { render } from "./HistorySheet.vue?vue&type=template&id=0c38590c&scoped=true"
import script from "./HistorySheet.vue?vue&type=script&lang=js"
export * from "./HistorySheet.vue?vue&type=script&lang=js"

import "./HistorySheet.vue?vue&type=style&index=0&id=0c38590c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c38590c"]])

export default __exports__